var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgTranReportIcon = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8535 20.124H13.4011V17.6485C13.4011 16.3772 12.0028 15.5744 10.9373 16.2435L0.749128 22.6663C-0.249709 23.3354 -0.249709 24.8071 0.749128 25.4093L10.9373 31.832C12.0028 32.5012 13.4011 31.7651 13.4011 30.4271V27.9515H25.8535C26.7192 27.9515 27.4516 27.2157 27.4516 26.3458V21.7295C27.4516 20.8599 26.719 20.124 25.8535 20.124Z",
    fill: "#C59331"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2494 6.67387L21.0613 0.251086C19.9958 -0.418031 18.5974 0.318066 18.5974 1.65607V4.1316L6.14501 4.13137C5.27928 4.13137 4.54688 4.86724 4.54688 5.73707V10.3534C4.54688 11.2233 5.27928 11.9591 6.14501 11.9591H18.5974V14.4347C18.5974 15.7059 19.9958 16.5088 21.0613 15.8397L31.2494 9.41687C32.2482 8.81473 32.2482 7.27601 31.2494 6.67388V6.67387Z",
    fill: "#03002F"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTranReportIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tranReportIcon.69445077450e8beb45a2fc26fd5b7e3d.svg";